import React from 'react'
import classNames from 'classnames'

export default ({ classes }) => (
	<div className={classes.loadingBlock}>
		<div className={classes.spinnerBox}>
			<div className={classes.pulseContainer}>
				<div className={classNames(classes.pulseBubble, classes.pulseBubble1)} />
				<div className={classNames(classes.pulseBubble, classes.pulseBubble2)} />
				<div className={classNames(classes.pulseBubble, classes.pulseBubble3)} />
			</div>
		</div>
	</div>
)
